import yaml from "js-yaml";

export type YamlContent = {
  title?: string;
  text?: string;
};

export type YamlSlug = "kontakt" | "rechtliches" | "datenschutz" | "impressum";

export type PublicSettings = {
  cta?: {
    tgChatUrl?: string;
    HomeUrl?: string;
  };
  features?: {
    aiAssistEnabled?: boolean;
    aiAssistUserToggleEnabled?: boolean;
    aiAssistUseCaseSummaryEnabled?: boolean;
    handbookEnabled?: boolean;
  };
  gating?: {
    enabled?: boolean | number;
    licenseServerUrl?: string;
    manualLicenseCodeEnabled?: boolean | number;
    stripeCheckoutEnabled?: boolean | number;
    digistoreMagicLinkEnabled?: boolean | number;
    launchOfferEnabled?: boolean | number;
    launchOfferTag?: string;
    manualCheckoutUrl?: string;
    supportUrl?: string;
    requestTimeoutMs?: number;
  };
  policy?: {
    baseVersion?: string;
    baseVersionLabel?: string;
    documentIdEnabled?: boolean | number;
  };
};

export async function loadYaml(slug: YamlSlug): Promise<YamlContent> {
  const response = await fetch(`/data/${slug}.yaml`);
  if (!response.ok) throw new Error(`Konnte ${slug}.yaml nicht laden.`);

  const data = yaml.load(await response.text());
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    throw new Error(`Ungueltige YAML-Struktur in ${slug}.yaml.`);
  }

  const { title, text } = data as Partial<YamlContent>;
  return {
    title: title ?? slug,
    text: text ?? ""
  };
}

export async function loadSettings(): Promise<PublicSettings> {
  const response = await fetch("/config/settings.yaml");
  if (!response.ok) throw new Error("Konnte settings.yaml nicht laden.");

  const data = yaml.load(await response.text());
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    throw new Error("Ungueltige YAML-Struktur in settings.yaml.");
  }

  return data as PublicSettings;
}
